/* R for Rabbit demo v4: cart and quantity polish (DESIGN-v4 5.8). Loaded with defer by
   snippets/cart-drawer.liquid and sections/main-cart.liquid. Delegated listeners only:
   the desktop drawer scrim and Escape close the drawer; a quantity stepper (product page or cart)
   ticks its number up or down. */
(() => {
  'use strict';
  const d = document;

  // Desktop: the cart drawer lays over the page with a scrim (.page-wrapper::after, rfr-cart.css).
  // A click on the scrim lands on .page-wrapper itself and closes the drawer, like a modal backdrop;
  // Escape closes it too.
  const cart = () => d.querySelector('theme-drawer#cart-drawer[open]');
  d.addEventListener('click', (e) => {
    const dr = cart();
    if (dr && e.target instanceof Element && e.target.classList.contains('page-wrapper') && innerWidth >= 990) dr.close();
  });
  d.addEventListener('keydown', (e) => {
    const dr = cart();
    if (e.key === 'Escape' && dr && innerWidth >= 990) dr.close();
  });
  d.addEventListener('click', (e) => {
    const btn = e.target instanceof Element ? e.target.closest('.quantity-selector button[name="plus"], .quantity-selector button[name="minus"]') : null;
    if (!btn) return;
    const input = btn.closest('.quantity-selector')?.querySelector('input[type="number"]');
    if (!input) return;
    const before = input.value;
    // Horizon's own handler sets the new value in this same click; read it right after.
    requestAnimationFrame(() => {
      if (input.value === before) return;
      const cls = btn.name === 'plus' ? 'rfr-tick-up' : 'rfr-tick-down';
      input.classList.remove('rfr-tick-up', 'rfr-tick-down');
      void input.offsetWidth; // restart the animation on repeated taps
      input.classList.add(cls);
      input.addEventListener('animationend', () => input.classList.remove(cls), { once: true });
    });
  });
})();
